import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { DuelSeriesService } from 'src/app/services/duel-series.service';

@Component({
  selector: 'app-video-layer',
  templateUrl: './video-layer.component.html',
  styleUrls: ['./video-layer.component.scss']
})
export class VideoLayerComponent implements OnInit {

  @Input() template: string = '';
  @Input() id: number = -1;

  public duelSeries: any = null;
  public duel: any = null;
  public player1Balls = [];
  public player2Balls = [];

  public ctx: Object = {};

  constructor(
    private duelSeriesService: DuelSeriesService,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    if (this.id) {
      this.updateTable();
    }
  }

  updateTable() {
    this.duelSeriesService.getTable(this.id).subscribe((table: any) => {
      if (table.active_ds_id) {
        this.duelSeriesService.get(table.active_ds_id).subscribe(ds => {
          this.duelSeries = ds;
          if (this.duelSeries.duels.length) {
            this.duel = this.duelSeries.duels[this.duelSeries.duels.length - 1];
          }

          if (this.duel) {
            this.player1Balls = this.duel.player_one_score > 0 ? [...Array(this.duel.player_one_score).keys()] : [];
            this.player2Balls = this.duel.player_two_score > 0 ? [...Array(this.duel.player_two_score).keys()] : [];
          } else {
            this.player1Balls = [];
            this.player2Balls = [];
          }

          if (this.duelSeries.player_one.full_name.split(' ').length - 1 >= 2) {
            const [last_name, first_name, surname] = this.duelSeries.player_one.full_name.split(' ');
            this.duelSeries.player_one.full_name = `${last_name} ${first_name}`;
          }

          if (this.duelSeries.player_two.full_name.split(' ').length - 1 >= 2) {
            const [last_name, first_name, surname] = this.duelSeries.player_two.full_name.split(' ');
            this.duelSeries.player_two.full_name = `${last_name} ${first_name}`;
          }

          if (this.duelSeries.player_one.full_name.length > 21) {
            const [last_name, first_name] = this.duelSeries.player_one.full_name.split(' ');
            this.duelSeries.player_one.full_name = `${last_name} ${first_name.substr(0, 1)}.`
          }

          if (this.duelSeries.player_two.full_name.length > 21) {
            const [last_name, first_name] = this.duelSeries.player_two.full_name.split(' ');
            this.duelSeries.player_two.full_name = `${last_name} ${first_name.substr(0, 1)}.`
          }
        });
      } else {
        this.duelSeries = null;
      }

      setTimeout(() => {
        this.updateTable();
      }, 3000);
    });
  }
}
